import { Badge, BadgeProps, styled } from "@mui/material";

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
	animation: "jump 4s ease-out infinite",
	"@keyframes jump": {
		"0%, 100%": {
			transform: "translateY(0)",
		},
		"10%": {
			transform: "translateY(-5px)",
		},
		"15%": {
			transform: "translateY(0)",
		},
		"20%": {
			transform: "translateY(-5px)",
		},
		"90%": {
			transform: "translateY(-5px)",
		},
	},
}));

export default function AnimatedBadge(props: BadgeProps) {
	return <StyledBadge {...props} />;
}
